(function () {
  var dataEl = document.getElementById('chatwoot-config-data');
  if (!dataEl) return;
  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (data.settings) window.CHATWOOT_SETTINGS = data.settings;
  if (data.user) {
    var user = data.user;
    if (user.custom_attributes && user.custom_attributes.referrer_placeholder) {
      user.custom_attributes.referrer = document.referrer || 'direct';
      delete user.custom_attributes.referrer_placeholder;
    }
    window.chatwootSettings = user;
  }
})();
